import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';
import useHover from 'base/hooks/useHover';
import { IElementTarget } from 'base/interfaces/common';
import { IProduct } from 'base/interfaces/product';
import styles from './index.module.less'
import PureVideo, { IPureVideoRef } from '@base/lib/PureVideo';
import { isVideoUrl } from 'base/utils/file';
import Link from '@base/lib/ThemeLink';
import ThemeLoading from '@base/lib/ThemeLoading';

export type IListProductImageHover = {
    itemImageClass?: string;    // hover 元素 （首页的列表第一次获取不到ref，使用id获取元素 ）
    hoverRef?: any;         // hover 元素
    aTarget?: IElementTarget;  // <a>标签跳转方式
    product: IProduct;
    linkProps: {
        picLink?: string;
        altText?: string;
        hoverAssetLink?: string;
        hoverAltText?: string;
    };
    imageSize?: number;
    canJump?: boolean;
}

const ListProductImageHover: React.FC<IListProductImageHover> = (props) => {
    const {
        itemImageClass,
        hoverRef,
        aTarget = '_self',
        product,
        imageSize = 365,
        canJump = true,
        linkProps = {},
        ...rest
    } = props;

    const selfHoverRef = useRef<HTMLDivElement>(null);
    const imgRef = hoverRef || selfHoverRef;

    const [hovering, setHovering] = useState<boolean>(false);
    const [showHover, setShowHover] = useState<boolean>(false);
    const [reloadCount, setReloadCount] = useState<number>(0)
    const videoRef = useRef<IPureVideoRef>(null);

    const { link, name } = product;

    const { hoverAltText, hoverAssetLink, picLink, altText } = linkProps

    const isVideoHoverLink = isVideoUrl(hoverAssetLink || '')

    const _href = canJump ? link : void 0
    const _alt = altText || name

    // hover 元素
    let el = imgRef?.current
    if (!el && process.browser && itemImageClass) {
        // (首页列表 useHover 第一次都获取不到 ref.current)
        el = document?.querySelector(`.${itemImageClass}`)
    }

    useHover(el, {
        onEnter: () => {
            setHovering(true)
            if (isVideoHoverLink) {
                videoRef.current?.play()
            }
        },
        onLeave: () => {
            setHovering(false)
            if (isVideoHoverLink) {
                videoRef.current?.pause()
            }
        }
    })

    useEffect(() => {
        //（首页列表 useHover 第一次都获取不到 ref）
        if (!el) {
            setReloadCount((preCount) => {
                return preCount + 1
            })
        }
    }, [reloadCount, el])

    useEffect(() => {
        setTimeout(() => {
            // 延后加载hover资源
            setShowHover(true)
        }, 3000)
    }, [])

    return (
        <div ref={hoverRef ? null : imgRef}
             className={cn(
                 'relative',
                 styles['images-wrap'],
                 { [styles['hovering']]: hovering }
             )}
        >
            <Image
                {...rest}
                target={aTarget}
                className={cn(
                    'relative', styles['main'],
                    { 'js-track-link': canJump }
                )}
                href={_href}
                src={picLink}
                alt={_alt}
                width={imageSize}
                height={imageSize}
            />

            {(showHover || hovering) && (
                <>
                    <div className={cn(styles['hover'])}>
                        {isVideoHoverLink ? (
                            <Link href={_href as any}>
                                <a className={styles['video-warp']} target={aTarget}>
                                    <PureVideo
                                        src={hoverAssetLink || ''}
                                        ref={videoRef}
                                        loop={true}
                                        muted={true}
                                        preload={'auto'}
                                    />
                                </a>
                            </Link>

                        ) : (
                            <Image
                                {...rest}
                                target={hoverAltText}
                                href={_href}
                                src={hoverAssetLink || ''}
                                alt={_alt}
                                width={imageSize}
                                height={imageSize}
                                className={cn({ 'js-track-link': canJump })}
                            />
                        )}
                    </div>

                </>
            )}

        </div>
    );
};

export default ListProductImageHover